<template>
  <div id="footerBox">
    <Map class="mapBox"></Map>
    <Relation id="relation"></Relation>
    <div class="copyRight">
      Copyright © 2017-{{year}} 浙江电马云车科技有限公司. All Rights Reserved.
      <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-left: 10px;text-decoration: none;color: rgba(7, 7, 7, 1);">浙ICP备17048109号-3</a>
    </div>
  </div>
</template>

<script>
import Map from '@/components/footer/Map.vue'
import Relation from '@/components/footer/Relation.vue'
export default {
  name: 'Footer',
  data: function () {
    return {
      map: {},
      year: ''
    }
  },
  components: {
    Map,
    Relation
  },
  created: function () {
    this.getYear()
  },
  methods: {
    getYear: function () {
      this.year = new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
#footerBox {
  width: 100%;
  min-width: 1300px;
  height: 700px;
  background-color: #efefef;
}
.copyRight{
  width: 100%;
  height:60px;
  font-size: 13px;
  color: rgba(7, 7, 7, 1);
  background-color: RGBA(248, 248, 248, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue